const routes = [
  { path: '/', redirect: '/results/search-results' },
  { path: '/results', redirect: '/results/search-results' },
  { path: '*', redirect: '/errors/404' },
]

export default routes
